import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'

import { selectPageIsMine, selectPageOwnerLogin, selectPageTitle } from './pagesSlice'

import { ListItem, Paper, Typography } from '@mui/material'

const classes = {
  root: {
    flexWrap: 'wrap',
  },
  paper: {
    backgroundColor: (theme) => theme.palette.common.white,
    width: '100%',
    padding: 1,
    border: '1px solid rgba(0, 0, 0, 0.12)',
    '&:hover': {
      cursor: 'pointer',
      boxShadow: 'none',
      border: '1px solid rgba(0, 0, 0, 0.12)',
    },
  },
  current: {
    cursor: 'default',
    backgroundColor: (theme) => theme.palette.info.light,
    color: (theme) => theme.palette.common.white,
    boxShadow: 'none',
    border: '1px solid rgba(0, 0, 0, 0.12)',
  },
}

// `action` is an optional control to show inside the entry, under the caption: a
// page someone shared with me carries "Remove from my pages" there. It sits inside
// the Paper, so whatever goes in has to stop its own click reaching the Paper's,
// which opens the page.
export default function PageLink({ pageId, currentPageId, action = null }) {
  const navigate = useNavigate()
  const isCurrentPage = pageId === currentPageId
  const title = useSelector(selectPageTitle(pageId))
  const isMine = useSelector(selectPageIsMine(pageId))
  const ownerLogin = useSelector(selectPageOwnerLogin(pageId))

  const handleClick = (e) => {
    if (!isCurrentPage) {
      navigate(`/app/pages/${pageId}`)
      e.preventDefault()
      e.stopPropagation()
    }
  }

  return (
    <ListItem sx={classes.root}>
      <Paper
        sx={
          isCurrentPage
            ? { ...classes.paper, ...classes.current }
            : classes.paper
        }
        elevation={2}
        onClick={handleClick}
      >
        <Typography variant='subtitle1' component='div'>
          {title}
        </Typography>
        {/* Say whose page it is, and that it is read-only, on the pages someone
            else shared with me. My own pages say nothing extra. */}
        {!isMine && (
          <Typography variant='caption' component='div'>
            {ownerLogin ? `Shared by ${ownerLogin}` : 'Shared with me'} · read only
          </Typography>
        )}
        {action}
        {/* <Typography variant='caption' component='div'>
          date:
        </Typography> */}
      </Paper>
    </ListItem>
  )
}
